export default __webpack_public_path__ + "static/media/mawiwlogo.e00846b1.png";